import { render, staticRenderFns } from "./QueryClarification.vue?vue&type=template&id=44199019&scoped=true"
import script from "./QueryClarification.vue?vue&type=script&lang=js"
export * from "./QueryClarification.vue?vue&type=script&lang=js"
import style0 from "./QueryClarification.vue?vue&type=style&index=0&id=44199019&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44199019",
  null
  
)

export default component.exports